/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";
import { nameof } from "../../../Basis/Utils/AnyUtil";

export interface Rollen {
    istAdministration: boolean;
    istSupport: boolean;
    istExperimentell: boolean;
    istEigentuemer: boolean;
    istNutzend: boolean;
    istTeilnehmend: boolean;
    istDozierend: boolean;
    hatGrundeinstellungenRecht: boolean;
}

export interface LadeEigeneMandantRollenInput {
    mandantKennungOderUrlBezeichnung: string;
}

export default class PromiseLadeEigeneMandantRollen extends PromiseQuery<Rollen, LadeEigeneMandantRollenInput> {
    public static readonly queryName = "Mandanten_LadeEigeneMandantRollen";

    private static readonly query = gql`
        query ${PromiseLadeEigeneMandantRollen.queryName} ($input: ${PromiseLadeEigeneMandantRollen.queryName}) {
            ${PromiseLadeEigeneMandantRollen.queryName} (input:$input) {
                ${nameof<Rollen>("istAdministration")}
                ${nameof<Rollen>("istSupport")}
                ${nameof<Rollen>("istExperimentell")}
                ${nameof<Rollen>("istEigentuemer")}
                ${nameof<Rollen>("istNutzend")}
                ${nameof<Rollen>("istTeilnehmend")}
                ${nameof<Rollen>("istDozierend")}
                ${nameof<Rollen>("hatGrundeinstellungenRecht")}
            }
        }
    `;

    public constructor() {
        super(PromiseLadeEigeneMandantRollen.query);
    }

    public get name(): string {
        return PromiseLadeEigeneMandantRollen.queryName;
    }
}